<template>
  <div>
    <iht-header ref="header" :detail="detail" :meta="meta" :gelombang="gelombang" @switch="onSwitchTab" />
    <component :is="formulir.component" :laporan="formulir.laporan || {}" :meta="meta" v-if="formulir.k_laporan" />
    <iht-rekap :laporan="detail[5] || {}" v-if="isBalai && formulir.k_laporan === 5" />
  </div>
</template>

<script>
import IhtHeader from './detail/Header';
import IhtBuka from './detail/IhtBuka';
import IhtTutup from './detail/IhtTutup';
import IhtRekap from './detail/IhtRekap';
import IhtAwal from './detail/IhtAwal';
import IhtPelaksanaan from './detail/IhtPelaksanaan';
import IhtEvaluasi from './detail/IhtEvaluasi';
import { mapState } from 'vuex';

export default {
  name: 'DetailIht',
  components: { IhtHeader, IhtBuka, IhtTutup, IhtRekap, IhtAwal, IhtPelaksanaan, IhtEvaluasi },
  props: {
    detail: {
      type: Object,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => {},
    },
    gelombang: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      isBalai: (state) => (state.data && state.data.balai) || false,
    }),
  },
  methods: {
    reset() {
      this.onSwitchTab(null);
      this.$refs.header.reset();
    },

    onSwitchTab(kLaporan) {
      const components = {
        4: 'IhtBuka',
        5: 'IhtTutup',
        6: 'IhtAwal',
        7: 'IhtPelaksanaan',
        8: 'IhtEvaluasi',
      };

      this.$set(this.formulir, 'k_laporan', kLaporan);
      this.$set(this.formulir, 'component', components[kLaporan]);
      this.$set(this.formulir, 'laporan', this.detail[kLaporan]);
    },
  },
};
</script>

<style scoped></style>
